export const kraftOneFace = 'Kraft';
export const whiteOneFace = 'Blanco una cara';
export const whiteTwoFaces = 'Blanco dos caras';
